import 'dayjs/locale/pt-br';
import { formatStringForSearch } from '../formatting';

export const getIfThisWeekdayEstablishmentIsOpen = (
  weekdayToValidate, businessHours,
) => {
  const isOpenOnThisWeekday = businessHours.some(
    ({ weekday, isActive }) => (isActive === true)
      && (formatStringForSearch(weekday)
        === formatStringForSearch(weekdayToValidate)),
  );

  return isOpenOnThisWeekday;
};
